import { render, staticRenderFns } from "./CoreDashboard.vue?vue&type=template&id=7f190113&scoped=true"
import script from "./CoreDashboard.vue?vue&type=script&lang=js"
export * from "./CoreDashboard.vue?vue&type=script&lang=js"
import style0 from "./CoreDashboard.vue?vue&type=style&index=0&id=7f190113&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f190113",
  null
  
)

export default component.exports